import { Button, Form } from 'antd';
import { $Formutil, withForm } from 'react-antd-formutil';
import { useLocation, useNavigate } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import OnetimeCode from 'components/OnetimeCode';
import Toast from 'components/Toast';
import Track from 'components/Track';
import store from '../../../store';
import { LocationStatesSuccessNextUrl } from './types';

interface VerfiyProps {
    $formutil: $Formutil;
}

const Verify: React.FC<VerfiyProps> = props => {
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state as LocationStatesSuccessNextUrl | null;

    const handleChange = async value => {
        if (value && value.length >= 6) {
            try {
                const { $invalid, $batchDirty, $getFirstError } = props.$formutil;

                if ($invalid) {
                    const firstError = $getFirstError();

                    Toast.show(firstError);
                    $batchDirty(true);

                    return;
                }

                Toast.loading(true);

                const params = { verify: 'signin,trade,fund', otp_code: value };

                const ret = await store.on2fa(params);

                if (ret.is_succ) {
                    Toast.show(__('两步验证开启成功'));
                    store.updateOtpEnable(true);

                    navigate(locationState?.successNextUrl || '/profile/security', { replace: true });
                } else {
                    Toast.show(__('两步验证开启失败'));
                }
            } catch (error) {
                const { error_code } = error;

                // 需要两步验证token
                if (error_code >= 11401 && error_code <= 11402) {
                    props.$formutil.$reset();
                }

                Toast.show(error);
            }

            Toast.loading(false);
        }
    };

    return (
        <div className="install-step install-step-verify">
            <h3>{__('请输入TradeUP Authenticator中显示的6位动态密码')}</h3>
            <Form>
                <OnetimeCode name="otp_code" $onFieldChange={handleChange} />
            </Form>
            <Track eventModel="安全中心" eventType="两步验证_开启" eventName="两步验证开启_上一步2">
                <CardButtonWrap>
                    <Button
                        type="primary"
                        size="large"
                        onClick={() => {
                            navigate(-1);
                        }}>
                        {__('上一步')}
                    </Button>
                </CardButtonWrap>
            </Track>
        </div>
    );
};

export default withForm(Verify);
